import React from "react";
import PageSerch from "./SerchDocters/Components/PageSerch";
import DynamicBreadcrumbs from "../../Uitiles/DynamicBreadcrumbs";

const TermsandConditions = () => {
    return (
        <div>
            <PageSerch />
            <DynamicBreadcrumbs />
            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="container">
                    <div className="dc-haslayout dc-haslayout page-data dc-parent-section dc-disabled">
                        <div className="main-page-wrapper">
                            <div className="dc-description">
                                <p>Welcome to <strong>Meddylist.com</strong>, a platform designed to connect patients with healthcare professionals. By using our services, you agree to comply with the following Terms and Conditions.</p>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />
                                
                                <h4 className="wp-block-heading"><strong>1. Scope of Services</strong></h4>
                                <p>Meddylist provides:</p>
                                <ul className="wp-block-list">
                                    <li>A searchable directory of licensed healthcare professionals.</li>
                                    <li>Appointment booking services for patients.</li>
                                    <li>Digital marketing tools for doctors.</li>
                                </ul>
                                <p>We do not provide medical advice or emergency healthcare services.</p>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>2. User Obligations</strong></h4>
                                <p><strong>For Patients:</strong></p>
                                <ul className="wp-block-list">
                                    <li>Ensure all provided information is accurate and up-to-date.</li>
                                    <li>Use the platform responsibly and respectfully.</li>
                                </ul>
                                <p><strong>For Doctors:</strong></p>
                                <ul className="wp-block-list">
                                    <li>Provide accurate and verifiable professional details.</li>
                                    <li>Respond promptly to appointment requests.</li>
                                    <li>Abide by all applicable medical and advertising regulations.</li>
                                </ul>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>3. Booking and Payment Policies</strong></h4>
                                <ul className="wp-block-list">
                                    <li>Appointments are booked directly with the selected healthcare provider.</li>
                                    <li>Payment terms, if applicable, are subject to the provider's policies.</li>
                                    <li>Meddylist does not directly handle disputes over payments or cancellations.</li>
                                </ul>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>4. Reviews and Feedback</strong></h4>
                                <ul className="wp-block-list">
                                    <li>Users can share honest reviews based on their experiences.</li>
                                    <li>Meddylist reserves the right to remove reviews containing offensive or defamatory language.</li>
                                </ul>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>5. Content Usage</strong></h4>
                                <p>All content, including doctor profiles, articles, and website visuals, is owned or licensed by Meddylist. Users may not reproduce or distribute content without prior consent.</p>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>6. Limitation of Liability</strong></h4>
                                <ul className="wp-block-list">
                                    <li>Meddylist acts as a connecting platform and is not responsible for the quality or outcome of medical consultations.</li>
                                    <li>We are not liable for losses or damages resulting from misuse of the platform.</li>
                                </ul>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>7. Termination and Suspension</strong></h4>
                                <ul className="wp-block-list">
                                    <li>Meddylist reserves the right to suspend or terminate accounts that violate our policies or engage in fraudulent activities.</li>
                                </ul>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>8. Governing Law</strong></h4>
                                <p>These Terms are governed by the laws of <strong>[Your Country/Region]</strong>. Disputes are subject to the jurisdiction of <strong>[Insert Region]</strong> courts.</p>
                                <hr className="wp-block-separator has-alpha-channel-opacity" />

                                <h4 className="wp-block-heading"><strong>9. Changes to Terms and Conditions</strong></h4>
                                <p>Updates to these Terms will be posted on the website, and continued use of our services constitutes acceptance of the changes.</p>
                                <p>For further questions, email us at info@meddylist.com.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default TermsandConditions;
